import { render, staticRenderFns } from "./VehicleDetailsContent.vue?vue&type=template&id=3ba44ca2&scoped=true"
import script from "./VehicleDetailsContent.vue?vue&type=script&lang=ts"
export * from "./VehicleDetailsContent.vue?vue&type=script&lang=ts"
import style0 from "./VehicleDetailsContent.vue?vue&type=style&index=0&id=3ba44ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba44ca2",
  null
  
)

export default component.exports